import { Aligner } from '@alfa-bank/site-aligner';
import { TextDesktop as Text } from '@alfa-bank/site-deprecated-text/desktop';
import { PureInput as Input } from '@alfa-bank/site-pure-input';
import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';

import { CodeInput as Component } from './code-input';
import type { TProps, IDeps } from './models';
import styles from './styles/desktop.css';

export const CodeInputDesktop = createWidget<IDeps, TProps>({
    Aligner,
    Input,
    Text,
    styles,
})(Component);
